interface ICurrentPageOptions {
  href: string;
  isExternal: boolean;
}

interface Options {
  pathname: string;
}

const useCurrentPage = ({ pathname }: Options) => {
  const getIsActivePage = ({ href, isExternal }: ICurrentPageOptions) => {
    const isActivePage =
      (pathname.startsWith('/' + href.split('/')[1]) ||
        pathname.startsWith('/dashboard') ||
        (pathname === '/' && href === '/dashboard')) &&
      !isExternal;

    const isStartPage = href === '/dashboard';

    return { isActivePage, isStartPage };
  };

  return { getIsActivePage };
};

export default useCurrentPage;
